import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled from 'styled-components'



class G30g extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;            
            background-color: #fff;
            padding: 20px 0 80px 0;            
        `

        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #555555;
            padding-bottom: 30px;
        `

        const AboutContainer = styled(Container)`
            padding: 10px 0 50px 0;
            @media (max-width: 500px) {
                padding: 50px 20px;
            }
        `

        const Heading = styled.h2`
            font-size: 60px;
            font-family: Poppins;
            color: #7dfa06;
            line-height: 80px;
            text-align: center;
            padding-bottom: 80px;        
        `

        return (
            <Section>
                <AboutContainer>
                    <Row>
                        <Col md={12}>
                            <Heading>Garantía de reembolso por 30 días</Heading>
                            <Text>
                                Garantizamos tu satisfacción. Si en los primeros 30 días no estás completamente satisfecho,
                                te reembolsamos sin preguntas. Tu confianza es nuestra prioridad. <b>Prueba sin Riesgo!</b>
                            </Text>
                        </Col>
                    </Row>
                </AboutContainer>
            </Section>

        )
    }
}

export default G30g